import React from 'react';
import { GrundlagenBeschreibung } from './grundlagen/GrundlagenBeschreibung';
import { GrundlagenMerkmale } from './grundlagen/GrundlagenMerkmale';
import { GrundlagenNutzung } from './grundlagen/GrundlagenNutzung';
import { GrundlagenPruefung } from './grundlagen/GrundlagenPruefung';
import { GrundlagenUmfang } from './grundlagen/GrundlagenUmfang';
import type { GrundlagenProps } from './grundlagen/typen';

/*
 * Reiter „Grundlagen" der Planungsphase. Die fuenf Abschnitte liegen einzeln
 * unter `grundlagen/` (gemeinsame Props in `grundlagen/typen.ts`, Schalter,
 * Zahlfeld und Pflichtzeile in `grundlagen/GrundlagenBausteine.tsx`). Hier
 * stehen sie wie bisher untereinander; der Leitfaden setzt sie einzeln auf
 * seine Stationen.
 */

type Props = GrundlagenProps & {
    /** Steht direkt unter der Baubeschreibung — die KI-Leiste, damit
     *  „Baubeschreibung auswerten" neben dem Text liegt, den sie liest. */
    nachBeschreibung?: React.ReactNode;
};

export const PlanungGrundlagen: React.FC<Props> = ({ nachBeschreibung, ...grundlagen }) => (
    <div className="space-y-6">

        {/* ─── Baubeschreibung ───────────────────────────────────── */}
        <GrundlagenBeschreibung {...grundlagen} />

        {nachBeschreibung}

        {/* ─── Kennzahlen und Leistungsphase ─────────────────────── */}
        <GrundlagenUmfang {...grundlagen} />

        {/* ─── Merkmale ──────────────────────────────────────────── */}
        <GrundlagenMerkmale {...grundlagen} />

        {/* ─── Nutzung und Zuständigkeit (keine Trigger) ──────────── */}
        <GrundlagenNutzung {...grundlagen} />

        {/* ─── Ergebnis der Prüfung ──────────────────────────────── */}
        <GrundlagenPruefung {...grundlagen} />
    </div>
);
